import React from 'react';
import PropTypes from 'prop-types';
import gql from 'graphql-tag';
import { Col, Row } from 'react-bootstrap';
import { Alert, Button } from '@storable/canaveral-components';
import FormFieldText from '../FormFieldText';
import Icon from '../../../modules/react/components/stateless/Icon';
import styles from './styles.scss';

const propTypes = {
  altField: PropTypes.string.isRequired,
  titleField: PropTypes.string.isRequired,
  image: PropTypes.shape({
    url: PropTypes.string.isRequired,
    filename: PropTypes.string.isRequired,
    trash: PropTypes.bool.isRequired,
  }).isRequired,
  handleReset: PropTypes.func.isRequired,
  sameMedia: PropTypes.bool,
  values: PropTypes.shape({
    primaryImage: PropTypes.shape({
      mediumId: PropTypes.string,
      alt: PropTypes.string,
      title: PropTypes.string,
    }),
    theme: PropTypes.shape({
      logo: PropTypes.shape({
        alt: PropTypes.string,
      }),
    }),
  }).isRequired,
};

const defaultProps = {
  sameMedia: false,
};

const FormFieldMediumRow = ({ image, altField, titleField, handleReset, values, sameMedia }) => (
  <>
    {sameMedia && (
      <Col xs={12}>
        <>
          <Alert context="info" className={styles.alert}>
            This image is being used as a facility primary image.
            You can change the image&apos;s Alt text and Title text above.
          </Alert>
        </>
      </Col>
    )}
    {image.trash && (
      <Col xs={12}>
        <Alert context="warning" className={styles.warning}>
          <Icon id="warning-triangle" label="deleted image" className={styles.warningIcon} />
          <div className={styles.warningText}>
            This image is in the trash and will not display on your website unless it&apos;s
            restored in the Media Gallery. The default image and alt text are currently
            displaying on your site.
          </div>
        </Alert>
      </Col>
    )}
    <Row>
      <Col xs={5}>
        <>
          <div className={styles.filename}>
            {image.filename}
          </div>
          <img
            alt={values ? values.theme.logo.alt : image.alt}
            className={styles.image}
            src={image.url}
          />
        </>
      </Col>
      <Col xs={5}>
        <FormFieldText
          label="Alt Text"
          name={altField}
          required
          data-testid="form-field-medium-alt"
          disabled={sameMedia}
        />
        <FormFieldText
          label="Title Text"
          name={titleField}
          disabled={sameMedia}
        />
      </Col>
      <Col xs={2}>
        <Button icon="trash" label="trash" context="bare" className={styles.resetButton} onClick={handleReset} />
      </Col>
    </Row>
  </>
);


FormFieldMediumRow.propTypes = propTypes;
FormFieldMediumRow.defaultProps = defaultProps;

FormFieldMediumRow.fragments = {
  medium: gql`
    fragment FormFieldMediumRowMedium on Medium {
      url
      filename
      defaultMetadata {
        title
        altText
      }
      trash
    }
  `,
};

export default FormFieldMediumRow;
